module.exports = __webpack_public_path__ + "static/media/comment-alt-times.afbcedac.svg";